import { get, post, put, patch, destroy } from "@rails/request.js"

window.chartLiquiditaetsverlauf = {
	data: {
		// Liqui
		bruttowerte: [],
		einnahmen: [],
		ausgaben: [],
		saldo: [],
		liquidierungen: [],
		ueberliquiditaeten: [],
		// Steuer
		gesamteinkuenfte: [],
		zu_versteuerndes_einkommens: [],
		steuerbetraege: [],
		durchschnittsbelastungen: [],
		grenzbelastungen: [],
		// Sonstiges
		startdatum: 0,
		enddatum: 0,
		anzeigeformat: "jahr",
		liquiditaetsverlaufId: "",
		einkommensteuerId: "",
	},

	chartsettings: {
		liquiditaetsverlauf_chart_id: "",
		bruttowerte_visible: "true",
		einnahmen_visible: "true",
		einnahmen_show_in_legend: "true",
		ausgaben_visible: "true",
		ausgaben_show_in_legend: "true",
		saldo_visible: "false",
		saldo_show_in_legend: "false",
		cash_pooling_visible: "true",
		gesamteinkuenfte_visible: "true",
		zu_versteuerndes_einkommens_visible: "true",
		steuerbetraege_visible: "true",
		durchschnittsbelastungen_visible: "true",
		grenzbelastungen_visible: "true",
	},

	showLoading() {
		if (this.chart) this.chart.showLoading()
	},

	hideLoading() {
		if (this.chart) this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.stockChart("chart_liquiditaetsverlauf", {
			chart: {
				chartType: "liqui", // ["liqui", "steuer"]
				events: {
					selection: function (event) {
						return zoomIn(chartLiquiditaetsverlauf, event)
					},
				},
			},

			tooltip: {
				pointFormatter: function () {
					if (this.y != 0) {
						return `<span>${this.series.name}: ${Highcharts.numberFormat(this.y, 0)}&nbsp;€</span>`
					} else return false
				},
			},

			xAxis: {
				ordinal: false,
				min: this.data.startdatum,
				max: this.data.enddatum,
				events: {
					afterSetExtremes: function (event) {
						const chart = event.target.chart,
							min = event.min,
							max = event.max

						updateDataGrouping(chart, min, max)
					},
				},
			},

			yAxis: [
				{},
				{
					opposite: true,
				},
			],

			legend: {
				enabled: true,
				events: {
					itemClick: async function (event) {
						const item = event?.legendItem
						const link = `/liquiditaetsverlauf_charts/${chartLiquiditaetsverlauf.chartsettings.liquiditaetsverlauf_chart_id}`
						const body = {
							[item.options.visibleAttributeName]: !item.visible,
						}
						const response = await put(link, {
							responseKind: "turbo-stream",
							body: JSON.stringify(body),
						})
					},
				},
			},

			plotOptions: {
				column: {
					point: {
						events: {
							click: function () {
								if (this.series.chart.options.chart.chartType === "liqui") {
									// Es kann nicht das Anzeigeformat aus data.anzeigeformat genommen werden (siehe #B460), weil wenn man kein Reset-Zoom macht das falsche Format drinsteht.
									const groupingEnabled =
										this.series.chart.options.plotOptions?.series?.dataGrouping?.enabled === true
									const anzeigeFormat = groupingEnabled ? "jahr" : "monat"
									const liquiditaetId = chartLiquiditaetsverlauf.data.liquiditaetsverlaufId

									detailansichtLiquiditaetsverlauf(this.x, anzeigeFormat, liquiditaetId)
								}

								if (this.series.chart.options.chart.chartType === "steuer") {
									const einkommensteuerId = chartLiquiditaetsverlauf.data.einkommensteuerId

									einkommensteuerShow(this.x, einkommensteuerId)
								}
							},
						},
					},
					cursor: "pointer",
				},
				series: {},
			},

			series: this.seriesLiqui(),
		})
		// Wenn der Chart Zeitraum kleiner ist als die Monatsgrenze das DataGrouping deaktivieren
		updateDataGrouping(this.chart, this.data.startdatum, this.data.enddatum)
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.seriesLiqui(), this.seriesSteuer()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		// xAchse: Min und Max aktualisieren
		this.updateXAxisMinMax()

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	updateXAxisMinMax() {
		const seriesMaxValues = this.chart.series.map((serie) =>
				Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined,
			),
			xAxisMaxValue = Math.max(this.data.enddatum, ...seriesMaxValues.filter((element) => element !== undefined))
		this.chart.xAxis[0].update({
			min: this.data.startdatum,
			max: xAxisMaxValue,
		})
	},

	updateSeriesData(seriesData, chartType) {
		// Alle Series entfernen
		while (this.chart.series.length > 0) {
			this.chart.series[0].remove(false)
		}

		// Series hinzufügen
		seriesData.forEach((serie) => {
			this.chart.addSeries(serie, false)
		})

		// XAchse Max Data prüfen und ggf. aktualisieren
		this.updateXAxisMinMax()

		// Text von yAxis1 anpassen (Liqui->Euro, Steuer->Prozent)
		text = chartType == "steuer" ? "Prozent" : "Euro"
		this.chart.yAxis[1].update({ title: { text: text } })

		// ChartType setzuen damit in der Detailansicht unterschieden werden kann ob liqui oder steuer
		this.chart.options.chart.chartType = chartType
		this.chart.redraw({ duration: chartAnimationDuration })
	},

	seriesLiqui() {
		return [
			{
				name: "Kontostand",
				id: "kontostand",
				legendName: "Kontostand",
				visibleAttributeName: "bruttowerte_visible",
				yAxis: 0,
				type: "area",
				color: farbeNettovermoegen,
				zIndex: 0,
				visible: this.chartsettings.bruttowerte_visible,
				data: this.data.bruttowerte,
			},
			{
				name: "Einnahmen",
				id: "einnahmen",
				legendName: "Einnahmen",
				visibleAttributeName: "einnahmen_visible",
				yAxis: 1,
				type: "column",
				color: farbeEinnahmen,
				index: 2,
				legendIndex: 2,
				zIndex: 2,
				stack: "ein_ausgaben",
				visible: this.chartsettings.einnahmen_visible,
				showInLegend: this.chartsettings.einnahmen_show_in_legend,
				data: this.data.einnahmen,
			},
			{
				name: "Ausgaben",
				id: "ausgaben",
				legendName: "Ausgaben",
				visibleAttributeName: "ausgaben_visible",
				yAxis: 1,
				type: "column",
				color: farbeAusgaben,
				index: 2,
				legendIndex: 3,
				zIndex: 2,
				stack: "ein_ausgaben",
				visible: this.chartsettings.ausgaben_visible,
				showInLegend: this.chartsettings.ausgaben_show_in_legend,
				data: this.data.ausgaben,
			},
			{
				name: "Saldo",
				id: "saldo",
				legendName: "Saldo",
				visibleAttributeName: "saldo_visible",
				yAxis: 1,
				type: "column",
				color: farbeEinnahmen,
				negativeColor: farbeAusgaben,
				index: 3,
				legendIndex: 2,
				zIndex: 2,
				stack: "ein_ausgaben",
				visible: this.chartsettings.saldo_visible,
				showInLegend: this.chartsettings.saldo_show_in_legend,
				data: this.data.saldo,
			},
			{
				name: "Automatische Liquidierung",
				id: "liquidierung",
				legendName: "Cash-Pooling",
				yAxis: 1,
				type: "column",
				color: farbeLiquidierung,
				index: 1,
				legendIndex: 4,
				zIndex: 2,
				stack: "ein_ausgaben",
				linkedTo: "ueberliquiditaet",
				data: this.data.liquidierungen,
			},
			{
				name: "Anlage Überliquidität",
				id: "ueberliquiditaet",
				legendName: "Cash-Pooling",
				visibleAttributeName: "cash_pooling_visible",
				yAxis: 1,
				type: "column",
				color: farbeLiquidierung,
				index: 1,
				legendIndex: 4,
				zIndex: 2,
				stack: "ein_ausgaben",
				visible: this.chartsettings.cash_pooling_visible,
				data: this.data.ueberliquiditaeten,
			},
		]
	},

	seriesSteuer() {
		return [
			{
				name: "steuerpflichtiges Einkommen",
				id: "summe_der_einkuenfte",
				legendName: "steuerpflichtiges Einkommen",
				visibleAttributeName: "gesamteinkuenfte_visible",
				type: "column",
				color: farbeSummeDerEinkuenfte,
				zIndex: 1,
				stacking: false,
				grouping: false,
				visible: this.chartsettings.gesamteinkuenfte_visible,
				data: this.data.gesamteinkuenfte,
			},
			{
				name: "zu versteuerndes Einkommen",
				id: "zve",
				legendName: "zu versteuerndes Einkommen",
				visibleAttributeName: "zu_versteuerndes_einkommens_visible",
				type: "column",
				color: farbeZuVersteuerndesEinkommen,
				zIndex: 1,
				stacking: false,
				grouping: false,
				visible: this.chartsettings.zu_versteuerndes_einkommens_visible,
				data: this.data.zu_versteuerndes_einkommens,
			},
			{
				name: "Steuerbetrag",
				legendName: "Steuerbetrag",
				visibleAttributeName: "steuerbetraege_visible",
				id: "einkommensteuer",
				type: "column",
				color: farbeSteuerBetrag,
				zIndex: 2,
				stacking: false,
				grouping: false,
				visible: this.chartsettings.steuerbetraege_visible,
				data: this.data.steuerbetraege,
			},
			{
				name: "Durchschnittsbelastung",
				legendName: "Durchschnittsbelastung",
				visibleAttributeName: "durchschnittsbelastungen_visible",
				id: "durchschnittsbelastung",
				type: "line",
				color: farbeBeitrag1,
				yAxis: 1,
				tooltip: {
					pointFormatter: function () {
						if (this.y != 0) {
							return `<span>${this.series.name}: ${Highcharts.numberFormat(this.y, 2)}&nbsp;%</span>`
						} else return false
					},
				},
				visible: this.chartsettings.durchschnittsbelastungen_visible,
				data: this.data.durchschnittsbelastungen,
			},
			{
				name: "Grenzbelastung",
				legendName: "Grenzbelastung",
				visibleAttributeName: "grenzbelastungen_visible",
				id: "grenzbelastung",
				type: "line",
				color: farbeNettovermoegen,
				yAxis: 1,
				tooltip: {
					pointFormatter: function () {
						if (this.y != 0) {
							return `<span>${this.series.name}: ${Highcharts.numberFormat(this.y, 2)}&nbsp;%</span>`
						} else return false
					},
				},
				visible: this.chartsettings.grenzbelastungen_visible,
				data: this.data.grenzbelastungen,
			},
		]
	},
}
